/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/social/social_styles';



/* ========== ~~~~~~~~~~ CTA : SOCIAL  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SocialLinks = (props) => {
	return (
		<div className={`social ${props.classes.social}`}>
			<p className={`message`}>Meanwhile, follow us:</p>
	        <Link name={`facebook`} type={`external`} action={url.social.facebook}><Icon name={`facebook-square`} style={`fab`} /></Link>
	        <Link name={`twitter`} type={`external`} action={url.social.twitter}><Icon name={`twitter`} style={`fab`} /></Link>
	        <Link name={`linkedin`} type={`external`} action={url.social.linkedin}><Icon name={`linkedin-in`} style={`fab`} /></Link>
	    </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SocialLinks);